import { Component } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent {
  public appPages = [
    { title: 'Asistencia', url: 'asistencia', icon: 'finger-print' },
    { title: 'Agrega Registro', url: 'registro', icon: 'duplicate' },
    { title: 'Permisos', url: 'permisos/agrega', icon: 'thumbs-up' },
    { title: 'Empleado', url: 'empleados', icon: 'people' },
  ];

  constructor() {}
  nomUsu : any = "";

  isLogin(){
    if(localStorage.getItem('IdEmp')){
      this.nomUsu = 'Bienvenido: ' + localStorage.getItem('NomUsu');
    }  

    if(localStorage.getItem('IdEmp')){
      return true;
    }else{
      return false;
    }    
  }

  CerrarSesion(){
    localStorage.removeItem('IdEmp');
    localStorage.removeItem('NomUsu');
  }
}
